module.exports = __webpack_public_path__ + "static/img/intro_img_4.4883b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro_img_4.png
// module id = ueRB
// module chunks = 0